import React from "react";
import Layout from "../Layout";

const NoMatch = ({}) => {
  return <Layout title="Ooppsss!"></Layout>;
};

export default NoMatch;
